(function () {
  const sliders = document.querySelectorAll("[data-grx-logo-slider]");
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const groups = Array.from(slider.querySelectorAll("[data-grx-logo-group]"));
    const dots = Array.from(slider.querySelectorAll("[data-grx-logo-dot]"));
    const previous = slider.querySelector("[data-grx-logo-prev]");
    const next = slider.querySelector("[data-grx-logo-next]");
    let index = 0;

    function show(nextIndex) {
      index = (nextIndex + groups.length) % groups.length;
      groups.forEach((group, groupIndex) => {
        group.hidden = groupIndex !== index;
      });
      dots.forEach((dot, dotIndex) => {
        dot.setAttribute("aria-current", dotIndex === index ? "true" : "false");
      });
    }

    previous && previous.addEventListener("click", () => show(index - 1));
    next && next.addEventListener("click", () => show(index + 1));
    dots.forEach((dot, dotIndex) => {
      dot.addEventListener("click", () => show(dotIndex));
    });

    show(0);
  });
})();
